import React from "react";

const Explanation = () => {
  return (
    <React.Fragment>
      <div>
        <h3>
          <span className="badge m-2">Explanation:</span>
        </h3>
        <details>
          <summary className="btn btn-light m-2">
            What is a Turing machine?
          </summary>
          <div className="card card-body m-2">
            <p>
              [Adapted from Wikipedia] A Turing machine is a mathematical model
              of computation that defines an abstract machine which manipulates
              symbols on a strip of tape according to a pre-specified table of
              rules. Despite the model's simplicity, given any computer
              algorithm, a Turing machine capable of simulating that algorithm's
              logic can be constructed.
            </p>
            <p>
              A Turing machine operates similarly to a finite-state automata,
              but is provided with a memory tape divided into cells. It
              positions its "head" over a cell and reads the symbol there. Then,
              determined solely by the symbol read, together with the machine's
              own present state, the machine writes a symbol in the cell, then
              either moves the tape head one cell left or right and transitions
              to another of finitely many states, according to a user-specified
              table of instructions.
            </p>
          </div>
        </details>
        <details>
          <summary className="btn btn-light m-2">
            What is the syntax for the code?
          </summary>
          <div className="card card-body m-2">
            <p>The format for the source code used above is as follows:</p>
            <p>
              The first two lines contain a header specifying what state to
              begin in and what contents to write to the tape initially:
            </p>
            <pre className="border border-secondary rounded bg-light">
              <code>
                $[initialState];
                <br />
                $[initialTapeContents];
                <br />
              </code>
            </pre>
            <p>
              The header is followed by as many lines as you like of
              instructions, each with the following syntax, and terminated by a
              semicolon:
            </p>
            <pre className="border border-secondary rounded bg-light">
              <code>
                in [startingState] [readCharacter] out [newState] [newCharacter]
                [move];
              </code>
            </pre>
            <p>There are a few other things you should be aware of:</p>
            <ul>
              <li>The move command must be one of either `left` or `right`.</li>
              <li>The symbol `_` denotes a blank character. </li>
              <li>
                The symbols `$` and `;` are reserved by the compiler (I also
                don't recommend using `^` as a character).
              </li>
              <li>The strings `in` and `out` are reserved keywords.</li>
            </ul>
            Other than that the state names can be any ASCII string, and the
            characters can be any ASCII character. Bitmoji not yet supported,
            sorry!
          </div>
        </details>
      </div>
    </React.Fragment>
  );
};

export default Explanation;
